export var ThemeOptions;
(function(ThemeOptions) {
    ThemeOptions["DARK"] = "dark";
    ThemeOptions["LIGHT"] = "light";
})(ThemeOptions || (ThemeOptions = {}));
export var ThemeSkin;
(function(ThemeSkin) {
    ThemeSkin["NONE"] = "none";
    ThemeSkin["GREEN"] = "light-green";
})(ThemeSkin || (ThemeSkin = {}));
export var ThemeSurface;
(function(ThemeSurface) {
    ThemeSurface["PRIMARY"] = "surface-primary";
    ThemeSurface["SECONDARY"] = "surface-secondary";
    ThemeSurface["TERTIARY"] = "surface-tertiary";
})(ThemeSurface || (ThemeSurface = {}));
